import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject, ISafetyCaseEnumLookup } from '../../interfaces'

const getMitigationTypesRequest = (): IGetRequestObject => ({
  method: 'get',
  url: `${config.baseUrl}/sms/Lookups/MitigationTypes`,
})

const useSafetyCaseHazardMitigationTypesQuery = buildGetQuery<undefined, undefined, ISafetyCaseEnumLookup[] | undefined>({
  getRequest: getMitigationTypesRequest,
  getQueryKey: () => ['mitigation-types'],
})

export default useSafetyCaseHazardMitigationTypesQuery
